var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubbleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.123,
    height: 32.781,
    viewBox: "0 0 35.123 32.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_comment",
    transform: "translate(65 -206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(-65 206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M9.2,34.781A1.17,1.17,0,0,1,8.025,33.61V27.757H4.512A3.517,3.517,0,0,1,1,24.244V5.512A3.517,3.517,0,0,1,4.512,2h28.1a3.517,3.517,0,0,1,3.512,3.512V24.244a3.517,3.517,0,0,1-3.512,3.512H18.387l-8.46,6.768A1.169,1.169,0,0,1,9.2,34.781ZM4.512,4.342A1.172,1.172,0,0,0,3.342,5.512V24.244a1.172,1.172,0,0,0,1.171,1.171H9.2a1.17,1.17,0,0,1,1.171,1.171v4.589l6.878-5.5a1.17,1.17,0,0,1,.732-.256H32.61a1.172,1.172,0,0,0,1.171-1.171V5.512A1.172,1.172,0,0,0,32.61,4.342Z",
    transform: "translate(-1 -2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(-57.975 215.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M26.9,12.342H8.171a1.171,1.171,0,0,1,0-2.342H26.9a1.171,1.171,0,1,1,0,2.342Z",
    transform: "translate(-7 -10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(-57.975 220.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M17.537,16.342H8.171a1.171,1.171,0,0,1,0-2.342h9.366a1.171,1.171,0,0,1,0,2.342Z",
    transform: "translate(-7 -14)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleIcon);
export default __webpack_public_path__ + "static/media/chatBubbleIcon.bfb413d1e38473bb2b84a5260ca38fc7.svg";
export { ForwardRef as ReactComponent };